import { QRCodeSVG } from "qrcode.react";
import { LogoMark } from "@/components/Logo";
import { SHOWROOM } from "@/lib/showroom";

const Row = ({ label, children, testId }) => (
  <div className="flex justify-between gap-6 border-t border-[#e6dfcc] py-2.5 text-[13px] text-[#14130f]" data-testid={testId}>
    <span className="font-mono-j text-[9px] tracking-[0.3em] uppercase text-[#8a857a] pt-1">{label}</span>
    <span className="text-right">{children}</span>
  </div>
);

export const PrintBackCover = () => {
  const site = window.location.origin;
  const bookUrl = `${site}/selection`;
  return (
    <section className="sheet cover back-cover flex flex-col justify-between" data-testid="print-back-cover">
      <div className="flex justify-between items-start text-[#9a7b26]">
        <span className="font-mono-j text-[10px] tracking-[0.3em] uppercase">Sterling Joinery</span>
        <span className="font-mono-j text-[10px] tracking-[0.3em] uppercase">Showroom</span>
      </div>

      <div>
        <h2 className="font-display font-light text-[58px] leading-[0.95] text-[#14130f]">
          Let's talk about<br /><em>your project.</em>
        </h2>
        <div className="mt-6 h-px w-24 bg-[#9a7b26]" />
        <p className="mt-6 text-[13px] leading-relaxed text-[#3b3933] max-w-[110mm]">
          Visit the showroom to see every board, stone and handle in this catalogue in person,
          or book a consultation and we'll bring the samples to you. Bring your shortlist —
          we'll turn it into a detailed quote.
        </p>

        <div className="mt-10 grid grid-cols-[1fr_auto] gap-10 items-end">
          <div>
            <Row label="Showroom" testId="back-cover-address">{SHOWROOM.address}</Row>
            <Row label="Phone" testId="back-cover-phone"><a href={SHOWROOM.phoneHref}>{SHOWROOM.phone}</a></Row>
            <Row label="Hours" testId="back-cover-hours">{SHOWROOM.hours}</Row>
            <Row label="Email" testId="back-cover-email"><a href={`mailto:${SHOWROOM.email}`}>{SHOWROOM.email}</a></Row>
            <Row label="Online" testId="back-cover-website"><a href={site}>{site.replace(/^https?:\/\//, "")}</a></Row>
          </div>
          <div className="flex flex-col items-center gap-3 border border-[#d9cfb4] p-4 bg-white" data-testid="back-cover-qr">
            <QRCodeSVG value={bookUrl} size={120} fgColor="#14130f" bgColor="#ffffff" level="M" />
            <p className="font-mono-j text-[8px] tracking-[0.25em] uppercase text-[#9a7b26] text-center leading-relaxed">
              Scan to book<br />a consultation
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-end">
        <LogoMark variant="dark" className="h-14 w-auto" />
        <p className="font-display italic text-[22px] text-[#14130f]/80">Made to measure.</p>
      </div>
    </section>
  );
};
